var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "range-input" }, [
    !_vm.hideValue
      ? _c("div", { staticClass: "range-input__value" }, [
          _vm.prefix
            ? _c("span", {
                staticClass: "range-input__value-prefix",
                domProps: { innerHTML: _vm._s(_vm.prefix) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", {
            staticClass: "range-input__value-value",
            domProps: { innerHTML: _vm._s(_vm.displayValue || _vm.value) }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      staticClass: "range-input__input",
      style: "--percent: " + _vm.percent + "%;",
      attrs: {
        type: "range",
        id: _vm.id,
        name: _vm.name,
        required: _vm.required,
        disabled: _vm.disabled,
        readonly: _vm.readonly,
        min: _vm.min,
        max: _vm.max,
        step: _vm.step
      },
      domProps: { value: _vm.value },
      on: {
        input: _vm.onInput,
        change: _vm.onInput,
        focus: _vm.onFocus,
        blur: _vm.onBlur,
        keyup: _vm.onKeyup,
        keydown: _vm.onKeydown,
        mouseup: _vm.onMouseup
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }